"use client";

import { useAuthContext } from "./authProvider";
import { t } from "@/lib/localization";

export default function Messages() {
    const { errorMessage, successMessage } = useAuthContext();

    if (successMessage) {
        return (
            <p className="-mb-4 -mt-2 text-sm font-medium text-center text-green-600">
                {t(successMessage.keyName, undefined, undefined)}
            </p>
        );
    } else if (errorMessage) {
        return (
            <p className="-mb-4 -mt-2 text-sm font-medium text-center text-red-600">
                {t(errorMessage.keyName, undefined, undefined)}
            </p>
        );
    }
}
